import React from "react";
import { Box, Typography, Paper, alpha, useTheme } from "@mui/material";
import {
  TableRestaurant,
  TakeoutDining,
  AccessTime,
} from "@mui/icons-material";
import OrderActionButton from "./OrderActionButton";

const DashboardQuickActionsSection = ({
  onCreateDineIn,
  onCreateTakeaway,
  isWaiter = false,
  dineInEnabled = true,
  takeawayEnabled = true,
}) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: "20px",
        bgcolor: "white",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        border: "1px solid",
        borderColor: alpha(theme.palette.divider, 0.08),
        boxShadow: `0 1px 3px ${alpha("#000", 0.04)}`,
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          borderColor: alpha("#667eea", 0.2),
          boxShadow: `0 8px 24px ${alpha("#667eea", 0.08)}`,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          mb: 3,
        }}
      >
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: `linear-gradient(135deg, ${alpha("#667eea", 0.15)}, ${alpha("#764ba2", 0.05)})`,
          }}
        >
          <AccessTime sx={{ fontSize: 22, color: "#667eea" }} />
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: theme.palette.text.primary,
            letterSpacing: "-0.5px",
            fontSize: "1.125rem",
          }}
        >
          Quick Actions
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5, flex: 1 }}>
        <OrderActionButton
          icon={TableRestaurant}
          label="Dine In Order"
          onClick={onCreateDineIn}
          variant="primary"
          disabled={!dineInEnabled}
        />
        {/* Only show Takeaway Order button if not a waiter */}
        {!isWaiter && (
          <OrderActionButton
            icon={TakeoutDining}
            label="Takeaway Order"
            onClick={onCreateTakeaway}
            variant="secondary"
            disabled={!takeawayEnabled}
          />
        )}
      </Box>
    </Paper>
  );
};

export default DashboardQuickActionsSection;
